import React from "react";
import AdminLayout from "@/pages/admin/AdminLayout";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { FileText, FileEdit, AlertTriangle, MapPin, HelpCircle, CheckCircle2 } from "lucide-react";

const Card = ({ label, value, icon: Icon, warn }) => (
  <div className="rounded-2xl bg-white border border-slate-200 p-5" data-testid={`seo-${label.toLowerCase().replace(/[^a-z]/g, "")}`}>
    <div className="flex items-center justify-between">
      <span className="text-sm font-semibold text-slate-500">{label}</span>
      <span className="w-9 h-9 rounded-lg flex items-center justify-center text-white" style={{ backgroundColor: warn && value > 0 ? "#d97706" : "var(--sc-emerald)" }}><Icon size={18} /></span>
    </div>
    <p className="mt-2 text-3xl font-extrabold text-slate-900" style={{ fontFamily: "Outfit" }}>{value}</p>
  </div>
);

export default function SeoAdmin() {
  const { data = {}, isLoading } = useQuery({ queryKey: ["admin-seo"], queryFn: () => api.get("/admin/seo").then((r) => r.data) });
  return (
    <AdminLayout>
      <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1" style={{ fontFamily: "Outfit" }}>SEO Dashboard</h1>
      <p className="text-slate-500 mb-6">Stato dei contenuti indicizzabili e coda editoriale.</p>
      {isLoading ? <p className="text-slate-500">Caricamento...</p> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
            <Card label="Guide pubblicate" value={data.published_guides ?? 0} icon={CheckCircle2} />
            <Card label="Guide in bozza" value={data.draft_guides ?? 0} icon={FileEdit} />
            <Card label="In revisione" value={data.in_review ?? 0} icon={FileText} warn />
            <Card label="Senza meta description" value={data.guides_without_meta ?? 0} icon={AlertTriangle} warn />
            <Card label="Rivenditori attivi" value={data.active_dealers ?? 0} icon={MapPin} />
            <Card label="FAQ totali" value={data.total_faqs ?? 0} icon={HelpCircle} />
          </div>
          <div className="mt-6 rounded-2xl bg-white border border-slate-200 p-6">
            <h2 className="font-bold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>Architettura SEO</h2>
            <p className="text-slate-600 text-sm leading-relaxed">Il sito è organizzato in topic cluster (SENIORCAR prodotto, Mobilità senior, Dispositivo medico, Centro Mobilità Senior) con breadcrumb, JSON-LD (Organization, WebSite, Product, Article, FAQPage, BreadcrumbList, LocalBusiness), canonical e robots gestiti per pagina. Le pagine programmatiche restano <b>noindex</b> finché non superano i requisiti di qualità.</p>
            <p className="text-slate-500 text-xs mt-3">sitemap.xml e robots.txt sono serviti staticamente. Le guide in bozza sono impostate su noindex.</p>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
